<template>
  <el-dialog title="Alterar a Logomarca da Imobiliária" :visible.sync="isVisible" :before-close="fechar" :close-on-click-modal="false" append-to-body v-loading="isLoading" width="35%">
    <el-form size="small" label-position="top" hide-required-asterisk	:show-message="false">
      <el-form-item>
        <el-upload ref="upload" name="arquivo" :action="''" :auto-upload="false" accept=".png, .jpg, .jpeg" :multiple="false" :limit="1" :on-exceed="handleFilesLimitExceed" class="file-upload-box">
          <el-button type="primary" slot="trigger" style="width: 100%" icon="el-icon-search" round class="btn-box-shadow">Selecionar Imagem</el-button>
          <div slot="tip">Imagens <b>jpg/png</b> com tamanho de até <b>1.5 MB</b></div>
        </el-upload>
      </el-form-item>
    </el-form>

    <span slot="footer">
      <el-button type="success" size="small" @click="handleClickButtonAlterarLogomarca" style="margin-left: 10px;" round class="btn-box-shadow">
        Alterar Logomarca
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { TAMANHO_MAXIMO_LOGO_IMOBILIARIA_EM_BYTES } from '../../../util/constantes';
import { mapActions, mapState } from 'vuex';
import URLS from '../../../util/urls';
import axios from 'axios';

export default {
  props: {
    isVisible: Boolean,
  },

  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    })
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading',
    ]),

    ...mapActions('loginStore', [
      'relogar',
    ]),

    handleClickButtonAlterarLogomarca() {
      this.validarUpload();
    },

    validarUpload() {
      const nenhumaImagemFoiSelecionada = this.$refs.upload.uploadFiles.length === 0;
      if(nenhumaImagemFoiSelecionada) {
        this.exibirAlerta('Selecione uma Imagem');
        return;
      }

      const arquivo = this.$refs.upload.uploadFiles[0].raw;

      const arquivoExcedeTamanhoLimite = arquivo.size > TAMANHO_MAXIMO_LOGO_IMOBILIARIA_EM_BYTES;
      if(arquivoExcedeTamanhoLimite) {
        this.exibirAlerta('O tamanho do arquivo excede 1.5 MB');
        return;
      }

      const TIPOS_DE_ARQUIVO = ['image/png', 'image/jpg', 'image/jpeg'];
      const tipoDoArquivoIsInvalido = !TIPOS_DE_ARQUIVO.includes(arquivo.type);
      if(tipoDoArquivoIsInvalido) {
        this.exibirAlerta('O tipo do arquivo é inválido');
        return;
      }

      this.handleAlterarLogomarca();
    },

    handleAlterarLogomarca() {
      const payload = new FormData();
      payload.append('arquivo', this.$refs.upload.uploadFiles[0].raw);
      payload.append('path', this.$refs.upload.uploadFiles[0].name);

      this.showLoading();
      
      this.alterarLogomarcaImobiliaria(payload)
        .then(this.handleResultadoAlterarLogomarcaImobiliaria)
        .catch(() => {
          this.$message.error('Não foi possível conectar-se ao servidor');
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    handleResultadoAlterarLogomarcaImobiliaria(resultado) {
      switch(resultado.status) {
        case 'SUCESSO':
          this.$message.success(resultado.mensagem);
          this.concluir(resultado);
          break;

        case 'ERRO':
          this.$message.error(resultado.mensagem);
      }
    },

    alterarLogomarcaImobiliaria(payload) {
      const config = { headers: { 'Content-Type': 'multipart/form-data' }};

      return axios.post(URLS.IMOBILIARIAS_ALTERAR_LOGOMARCA, payload, config)
        .then(response => {
          switch(response.data.status) {
            case 'SESSAO_EXPIRADA':
              return this.relogar().then(authResponse => {
                if(authResponse.status === 'SUCESSO') {
                  return this.alterarLogomarcaImobiliaria(payload);
                }
              }).catch(error => {
                throw error;
              });
            default:
              return response.data;
          }
        }).catch(error => {
          throw error;
        });
    },

    handleFilesLimitExceed() {
      this.exibirAlerta('Remova o arquivo atualmente selecionado');
    },

    concluir(resultado) {
      this.reset();
      this.$emit('alterar', resultado);
    },

    fechar() {
      this.reset();
      this.$emit('close');
    },

    exibirAlerta(mensagem) {
      this.$alert(mensagem, 'Atenção', { confirmButtonText: 'OK', type: 'warning' });
    },

    reset() {
      this.$refs.upload.clearFiles();
    },
  },
}
</script>

<style>
.file-upload-box .el-upload {
  margin-top: 5px;
  display: block !important;
}
</style>